import { useContext } from "react";
import { ApiContext } from "../../context/MyContext";
import { useCommsIdentity } from "./useCommsIdentity";

/**
 * The logged-in user's own display name, for attributing their messages.
 *
 * `empName` alone is not enough. It is written only by the OTP login path and
 * by the `employee_info` localStorage rehydrate — `useEmployeeVerification`
 * populates `employeeData` but not `empName` — so a session that never wrote
 * that key renders an empty name even though the profile is loaded. This walks
 * the same fallback chain `AppSidebar` already uses for exactly that reason,
 * then the shared comms identity cache as a last resort before "You".
 *
 * @returns {string} A non-empty display name.
 */
export function useViewerName() {
  const { empName, empId, employeeData, userProfileData } =
    useContext(ApiContext);
  const { getCoachName } = useCommsIdentity();

  const profile = userProfileData?.profile;
  const employee = employeeData?.data;

  return (
    [profile?.first_name, profile?.last_name].filter(Boolean).join(" ") ||
    (typeof empName === "string" && empName.trim()) ||
    [employee?.first_name, employee?.last_name].filter(Boolean).join(" ") ||
    profile?.full_name ||
    employee?.full_name ||
    employee?.name ||
    (empId != null ? getCoachName(empId) : undefined) ||
    "You"
  );
}
